import {Suspense} from 'react'
import styled from 'styled-components'
import {LoadingComponent} from '@components/lib'
import * as PropTypes from 'prop-types'

import Navigation from 'components/Navigation'
import Footer from 'components/Footer'

const Content = styled.div({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
})

const MainLayout = ({children}) => (
  <>
    <Navigation />
    <Content>
      <Suspense fallback={<LoadingComponent isAbsolute />}>{children}</Suspense>
    </Content>
    <Footer />
  </>
)

MainLayout.propTypes = {
  children: PropTypes.node,
}

export default MainLayout
